<!-- Shows a red cross at the bottom of the icon-->
<script>
  import Cross_bottom_right from "../../assets/svg/Cross_bottom_right.svelte"

  export let size = "w-12 h-12"
</script>

<div class={size + " relative"}>
  <div class="absolute left-0 top-0">
    <slot />
  </div>
  <div class="absolute left-0 top-0">
    <Cross_bottom_right class={size} color="red" />
  </div>
</div>
